import getBIEvent from './events';
import _ from 'lodash';

class BIReporter {
    constructor(biService, pageUrl) {
        this.userCodeControllerIds = biService.userCodeContextIds;
        this.viewMode = biService.viewMode;
        this.restrictedReporters = _.mapValues(biService.reporters, (reportFunc) => _.once(reportFunc));
        this.pageUrl = pageUrl;
    }

    report({eventName, params}) {
        if (this.restrictedReporters.reportBI) {
            this.restrictedReporters.reportBI(getBIEvent(eventName), params);
        }
    }

    reportWixCodeInteraction({controllerId, appDefinitionId}) {
        if (_.isNil(this.viewMode)) {
            return;
        }

        if (this.isUserCode(appDefinitionId, controllerId)) {
            const params = {pageUrl: this.pageUrl};
            this.report({eventName: `$W_INTERACTION_${_.upperCase(this.viewMode)}`, params});
        }
    }

    isUserCode(appDefinitionId, controllerId) {
        return _.isUndefined(appDefinitionId) && _.isUndefined(controllerId) || _.includes(this.userCodeControllerIds, controllerId);
    }
}

export default BIReporter;